<template>
	<div>
		<h1 style="margin-bottom: 10px; color: black">Group Chat Log</h1>
		<v-btn-toggle style="width: 100%; margin-bottom: 0px" mandatory>
			<v-btn @click="isBrowse = true" style="width: 50%">Browse</v-btn>
			<v-btn @click="isBrowse = false" style="width: 50%">Search</v-btn>
		</v-btn-toggle>
		<div v-if="isBrowse">
			<v-card>
				<v-card-text>
					<v-toolbar flat color="white" class="d-flex flex-row align-end justify-end" style="padding-top: 100px">
						<v-row>
							<v-col cols="6">
								<v-select item-text="name" item-value="guid" :items="roomList" v-model="selectedBrowseRoom" placeholder="Select Group"></v-select>
							</v-col>
							<v-col cols="2">
								<v-btn :disabled="processing" color="primary" dark class="mb-2" @click="getLog">FILTER</v-btn>
							</v-col>
							<v-col cols="4">
								<v-btn :disabled="!isDownloadable" color="primary" dark class="mb-2 ml-5" @click="downloadCSV(selectedBrowseRoom)">
									<v-icon dark left>mdi-download</v-icon>CSV
								</v-btn>
							</v-col>
						</v-row>
					</v-toolbar>
				</v-card-text>
				<v-data-table :headers="headers" :items="bLogs" item-key="id" class="elevation-1">
					<template v-slot:expanded-item="{ headers }">
						<td :colspan="headers.length" style="padding: 5px">
							<v-simple-table style="background-color: #f5f5f5"></v-simple-table>
						</td>
					</template>
				</v-data-table>
			</v-card>
		</div>
		<div v-else>
			<v-card>
				<v-card-text>
					<v-toolbar flat color="white" class="d-flex flex-row align-end justify-end" style="padding-top: 100px">
						<v-row>
							<v-col cols="2">
								<v-text-field v-model="searchKey" label="Key" single-line hide-details></v-text-field>
							</v-col>

							<v-col cols="2">
								<v-select item-text="name" item-value="guid" :items="roomList" v-model="selectedRoom" placeholder="Select Group"></v-select>
							</v-col>

							<v-col cols="2">
								<v-menu v-model="isShowStart" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="290px">
									<template v-slot:activator="{ on }">
										<v-text-field v-on="on" v-model="start" label="From Date" single-line readonly hide-details append-icon="mdi-calendar-today"></v-text-field>
									</template>
									<v-date-picker v-model="start" @input="isShowStart = false"></v-date-picker>
								</v-menu>
							</v-col>

							<v-col cols="2">
								<v-menu v-model="isShowEnd" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="290px">
									<template v-slot:activator="{ on }">
										<v-text-field v-on="on" v-model="end" label="To Date" single-line readonly hide-details append-icon="mdi-calendar-today"></v-text-field>
									</template>
									<v-date-picker v-model="end" @input="isShowEnd = false"></v-date-picker>
								</v-menu>
							</v-col>

							<v-col cols="2">
								<v-btn :disabled="processing" color="primary" dark class="mb-2" @click="getLog">FILTER</v-btn>
							</v-col>
							<v-col cols="2">
								<v-btn :disabled="!isDownloadable" color="primary" dark class="mb-2" @click="downloadCSV(selectedRoom)">
									<v-icon dark left>mdi-download</v-icon>CSV
								</v-btn>
							</v-col>
						</v-row>
					</v-toolbar>
				</v-card-text>
				<v-data-table :headers="headers" :items="sLogs" :search="search" item-key="id" class="elevation-1">
					<template v-slot:expanded-item="{ headers }">
						<td :colspan="headers.length" style="padding: 5px">
							<v-simple-table style="background-color: #f5f5f5"></v-simple-table>
						</td>
					</template>
				</v-data-table>
			</v-card>
		</div>
	</div>
</template>

<script>
import axios from "axios";
import configuration from "../../../../configuration";

const apiKey = configuration.apiKeyCometChat;
const appId = configuration.appIdCometChat;

export default {
	data() {
		return {
			isBrowse: true,
			search: "",
			searchKey: null,
			start: null,
			end: null,
			epochStart: null,
			epochEnd: null,
			bLogs: [],
			sLogs: [],
			headers: [
				{ text: "Sender Name", value: "from", sortable: false },
				{ text: "Sender Email", value: "fromEmail", sortable: false },
				{ text: "Receiver", value: "to", sortable: false },
				{ text: "Message", value: "message", sortable: false },
				{ text: "Sent", value: "sent", sortable: false }
			],
			isShowStart: false,
			isShowEnd: false,
			roomList: [],
			selectedRoom: null,
			selectedBrowseRoom: null,

			processing: false,
			isDownloadable: false
		};
	},
	props: ["experienceId"],
	created: async function() {
		await this.getGroup();
		await this.getLog();
	},
	methods: {
		toHexString(text) {
			var result = "";
			for (var i = 0; i < text.length; i++) {
				result += text.charCodeAt(i).toString(16);
			}
			if (result.length > 100) {
				result = result.substring(0, 100);
			}
			return result;
		},

		getLog() {
			if (this.isBrowse) {
				this.searchKey = null;
				this.start = null;
				this.end = null;
				this.epochStart = null;
				this.epochEnd = null;
			} else {
				if (this.start != null && this.end != null) {
					var sDate = this.start.split("-")[2];
					var sMonth = this.start.split("-")[1];
					var sYear = this.start.split("-")[0];

					var eDate = this.end.split("-")[2];
					var eMonth = this.end.split("-")[1];

					var eYear = this.end.split("-")[0];

					this.epochStart = new Date(sYear, sMonth - 1, sDate, 0, 0, 0).getTime() / 1000;
					this.epochEnd = new Date(eYear, eMonth - 1, eDate, 0, 0, 0).getTime() / 1000;
				}
			}

			this.processing = true;
			this.isDownloadable = false;

			if (this.$store.state.isUseCometChat) {
				let convoId = "group_" + (this.isBrowse ? this.selectedBrowseRoom : this.selectedRoom);
				let type = "groups";

				axios
					.post("/system/chat/log", {
						type: type,
						apiKey: apiKey,
						appId: appId,
						searchKey: this.searchKey != null ? encodeURI(this.searchKey) : this.searchKey,
						start: this.epochStart,
						end: this.epochEnd,
						conversationId: convoId
					})
					.then(response => {
						if (this.isBrowse) {
							this.bLogs = [];
						} else {
							this.sLogs = [];
						}
						for (var i = 0; i < response.data.data.length; i++) {
							if (response.data.data[i].receiverType != "user") {
								let date = new Date(0);
								date.setUTCSeconds(response.data.data[i].sentAt);

								if (this.isBrowse) {
									this.bLogs.push({
										id: response.data.data[i].id,
										from: response.data.data[i].data.entities.sender.entity.name,
										fromEmail: response.data.data[i].senderEmail,
										to: response.data.data[i].data.entities.receiver.entity.name,
										message: response.data.data[i].data.text.replace(/\n/g, ""),
										sent: date.toUTCString()
									});
								} else {
									this.sLogs.push({
										id: response.data.data[i].id,
										from: response.data.data[i].data.entities.sender.entity.name,
										to: response.data.data[i].data.entities.receiver.entity.name,
										message: response.data.data[i].data.text.replace(/\n/g, ""),
										sent: date.toUTCString()
									});
								}
							}
						}
						this.processing = false;
						this.isDownloadable = true;
					})
					.catch(() => {});
			} else {
				axios
					.post("/system/vchat/log", {
						type: "public",
						searchKey: this.searchKey != null ? encodeURI(this.searchKey) : this.searchKey,
						start: this.start,
						end: this.end,
						roomToken: this.isBrowse ? this.selectedBrowseRoom : this.selectedRoom,
						experienceId: this.experienceId
					})
					.then(response => {
						if (response.data) {
							if (this.isBrowse) {
								this.bLogs = [];
							} else {
								this.sLogs = [];
							}
							for (let i = 0; i < response.data.length; i++) {
								if (this.isBrowse) {
									this.bLogs.push({
										id: response.data[i].message_id,
										from: response.data[i].sender.user_first_name + " " + response.data[i].sender.user_last_name,
										fromEmail: response.data[i].sender.user_email,
										to: response.data[i].room_name,
										message: response.data[i].message_content.replace(/<p>/g, "").replace(/<\/p>/g, ""),
										sent: response.data[i].message_created_at
									});
								} else {
									this.sLogs.push({
										id: response.data[i].message_id,
										from: response.data[i].sender.user_first_name + " " + response.data[i].sender.user_last_name,
										fromEmail: response.data[i].sender.user_email,
										to: response.data[i].room_name,
										message: response.data[i].message_content.replace(/<p>/g, "").replace(/<\/p>/g, ""),
										sent: response.data[i].message_created_at
									});
								}
							}
						}
						this.processing = false;
						this.isDownloadable = true;
					})
					.catch(() => {});
			}
		},
		async getGroup() {
			this.roomList = [];
			let experienceId = this.experienceId;

			if (this.$store.state.isUseCometChat) {
				axios.post("/system/chat/group/list", { experienceId }).then(response => {
					let publicRooms = [];

					if (response.data.data.length > 0) {
						publicRooms = response.data.data;
						publicRooms = [
							...response.data.data.filter(room => {
								return room.metadata && room.metadata.experienceId && room.metadata.experienceId == experienceId;
							})
						];

						this.roomList = publicRooms;
					}
				});
			} else {
				axios.get("/system/vchat/room/group/list?experienceId=" + experienceId).then(response => {
					if (response.data) {
						this.roomList = response.data;
					}
				});
			}
		},
		downloadCSV(room) {
			let csv = "Sender Name, Sender Email, Receiver, Message, Sent\n";

			if (this.isBrowse) {
				this.bLogs.forEach(row => {
					csv = csv + row.from + "," + row.fromEmail + "," + row.to + "," + row.message + "," + row.sent + "\n";
				});
			} else {
				this.sLogs.forEach(row => {
					csv = csv + row.from + "," + row.to + "," + row.message + "," + row.sent + "\n";
				});
			}

			let anchor = document.createElement("a");
			anchor.href = "data:text/csv;charset=utf-8," + encodeURIComponent(csv);
			anchor.target = "_blank";

			let fileName = this.roomList.filter(function(x) {
				return x.guid == room;
			});

			anchor.download = fileName[0].name + "-chat-log.csv";
			anchor.click();
		}
	}
};
</script>